import { render, staticRenderFns } from "./AdminProfile.vue?vue&type=template&id=2953fa8d"
import script from "./AdminProfile.vue?vue&type=script&lang=js"
export * from "./AdminProfile.vue?vue&type=script&lang=js"
import style0 from "./AdminProfile.vue?vue&type=style&index=0&id=2953fa8d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports